var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-sheet',{staticClass:"mb-4"},[_c('v-simple-table',_vm._g(_vm._b({},'v-simple-table',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }